<template>
  <section id="our-story" class="story">
    <div class="story__inner">
      <p class="eyebrow">Our story</p>
      <blockquote class="story__quote">
        Never printed, always human. Every piece is made by hand, and no two are the same.
      </blockquote>
      <div class="story__body">
        <p>Walls &amp; Faces is a small shop of vintage art and interiors. Every painting, ceramic and rug we sell is a unique, handmade piece of art, shaped by a person rather than a machine. You won’t find a print, a copy or a second edition here.</p>
        <p>Each one carries the marks of the hands that made it, and is priced to be lived with, not locked away. Because real art doesn’t have to cost a fortune.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OurStory',
}
</script>

<style scoped>
.story {
  background: var(--paper);
  padding: 12rem 4rem;
  scroll-margin-top: 10rem;
}

.story__inner {
  max-width: 88rem;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
}

.story__quote {
  font-family: var(--font-display);
  font-style: italic;
  font-size: clamp(3rem, 4vw, 4.8rem);
  line-height: 1.2;
  color: var(--ink);
}

.story__body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3.2rem;
  text-align: left;
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.75;
  color: var(--charcoal);
}

@media (max-width: 960px) {
  .story { padding: 7.2rem 1.6rem; }
  .story__body { grid-template-columns: 1fr; gap: 1.6rem; }
}
</style>
